<mat-card *ngIf="card.display != 'Off'" style="min-height: 100px; padding: 0; display: flex; flex-direction: row;">
    <div style="display: flex; flex-direction: column; flex: 1">
        <div class="header-color" style="display: flex; flex-direction: row;">
            <div style="color: white; padding: 10px; display: flex; flex: 1;">
                <span class="robotoMedium" style="font-size: 14pt;" translate>Communication Log</span>
                <div style="padding-left: 20px; display: flex; align-items: center;">
                    10 most recent entries
                </div>
            </div>
            <div style="display: flex; flex: 1; flex-direction: row;">
                <div
                    style="display: flex; flex-direction: column; flex: 1; align-items: flex-end; padding-right: 5px; justify-content: center">
                    <button mat-stroked-button class="mat-card-button" (click)="goToCommunication()">
                        <span translate>Go To Communication Log</span>
                    </button>
                </div>
            </div>
        </div>
        <div style="display: flex; flex-direction: column; flex: 1; flex-wrap: wrap; justify-content: center">
            <div *ngIf="isShowStaffOption" style="flex: 1;display: flex;justify-content: flex-end;padding: 10px;">
                <tyl-checkbox [(checked)]='showAllStaffEntries' (change)="hideShowStaffCol();">Show entries created by
                    all staff</tyl-checkbox>
            </div>
            <div *ngIf="!communicationLogs || !communicationLogs.length"
                style="flex: 1;display: flex;justify-content: center;padding: 10px;">
                No Communication Log available.
            </div>
            <div>
                <mat-table *ngIf="communicationLogs && communicationLogs.length" style="width: 100%;"
                    [dataSource]="dataSource" multiTemplateDataRows>
                    <ng-container matColumnDef="More">
                        <mat-header-cell *matHeaderCellDef>
                            <!-- <i class="detail-row-collapsed-icon material-icons" aria-hidden="true"></i> -->
                            <i [ngClass]="isExpandAll ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'"
                                class="material-icons" (click)="expandAll()" aria-hidden="true"></i>


                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <span aria-label="Expand row for more details">
                                <i [ngClass]="checkExpanded(element) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'"
                                    class="material-icons" aria-hidden="true"></i>
                            </span>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="DateTime">
                        <mat-header-cell *matHeaderCellDef>Date/Time</mat-header-cell>
                        <mat-cell *matCellDef="let element">{{element.Date|date:'MM/dd/yy h:mm a'}}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="ContactPerson">
                        <mat-header-cell *matHeaderCellDef
                            [ngStyle]="{'width': showAllStaffEntries == true ? '120px' : '200px' }">Contact Person
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element"
                            [ngStyle]="{'width': showAllStaffEntries == true ? '120px' : '200px' }">
                            <span>{{getContectPerson(element.ContactPersonId)}}</span>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="ContactBy">
                        <mat-header-cell *matHeaderCellDef>Contacted By</mat-header-cell>
                        <mat-cell *matCellDef="let element">{{element.StaffName}}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="Subject">
                        <mat-header-cell *matHeaderCellDef
                            [ngStyle]="{'width': showAllStaffEntries == true ? '100px' : '260px' }">Subject
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element"
                            [ngStyle]="{'width': showAllStaffEntries == true ? '100px' : '260px' }">
                            {{element.Subject}}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="expandedDetail">
                        <mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length"
                            style="width:100%;display: flex;flex-direction: column;">
                            <div style="width:100%;" class="mat-detail-card" *ngIf="dataSource.checkVisible(element)">
                                <div style="width: 100%;">
                                    <span>Comments</span><br>
                                    <tyl-quill-text-only [padding]="0" [width]="'450px'"
                                        [html]="toTrustedHtml(element.Notes, true, true)" placeholder="">
                                    </tyl-quill-text-only>

                                </div>
                            </div>
                        </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns; let i = index;"
                        id="healthVisitLogDataRow{{i}}" tabindex="0"
                        [ngStyle]="{'border-bottom-width':checkExpanded(row) ? '0px' : '1px'}"
                        style="padding:0px;overflow: hidden;" matRipple (click)="toggleExpanded(row)"
                        (keydown)="rowKeyPress($event, row)">
                    </mat-row>
                    <mat-row *matRowDef="let row; columns: ['expandedDetail']"
                        [@detailExpand]="row.Notes != null && row.Notes.length > 0 && checkExpanded(row) ? 'expanded' : 'collapsed'"
                        (@detailExpand.start)="$event.toState == 'expanded' ? dataSource.setVisible(row, true) : null"
                        (@detailExpand.done)="$event.toState == 'collapsed' ? dataSource.setVisible(row, false) : null"
                        style="overflow: hidden;" class="mat-detail-row">
                    </mat-row>
                </mat-table>
            </div>
        </div>
    </div>
</mat-card>